import { h, render, Component } from "preact";
import Required from "./Required";
import Description from "./Description";

class CheckboxField extends Component {
  constructor(props) {
    super(props);
    this.state = {
      focus: false
    };
    this.checkboxBlur = this.checkboxBlur.bind(this);
    this.checkboxFocus = this.checkboxFocus.bind(this);
  }

  checkboxFocus() {
    this.setState({
      focus: true
    });
  }
  checkboxBlur() {
    this.setState({
      focus: false
    });
  }

  render() {
    const { focus } = this.state;
    const {
      input,
      label,
      description,
      required,
      meta: { touched, error, warning }
    } = this.props;
    let checked = false;
    if (input && (input.value === "true" || input.value === true)) {
      checked = true;
    }
    return (
      <div class={touched && error ? "form-group has-error" : "form-group"}>
        <label for={input.name} class="form-checkbox">
          <input
            type="checkbox"
            id={input.name}
            {...input}
            checked={checked}
            aria-label={`${label}`}
            onFocus={this.checkboxFocus}
            onBlur={this.checkboxBlur}
            aria-required={required ? "true" : "false"}
            aria-describedby={`${input.name}Error`}
          />
          <i
            class="form-icon"
            style={{ border: focus ? "2px solid blue" : "1px solid #8d949e" }}
          />{" "}
          {label}
          <Required required={required} />
          <Description description={description} />
        </label>
        {touched && error && (
          <p class="form-input-hint" id={`${input.name}Error`}>
            {error}
          </p>
        )}
      </div>
    );
  }
}

export default CheckboxField;



// WEBPACK FOOTER //
// ./components/fields/CheckboxField.js